module.exports = __webpack_public_path__ + "img/POS-money.5ea22712.png";